import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';

import { RouterModule } from '@angular/router';
import { MessageService } from 'primeng/api'

@NgModule({
  declarations: [],
  imports: [
    SharedModule,
    RouterModule.forChild(
      [
        {
          path: '',
          loadComponent: () => import('./manage-dashboard.component').then(m => m.ManageDashboardComponent)
        }
      ]
    )
  ],
  providers: [

  ],
})
export class ManageDashboardModule { }
